import { isNil } from 'ramda'
import { Observable, Subject, SubscriptionLike } from 'rxjs'
import connectClearRefinements, {
    ClearRefinementsConnectorParams as CParams,
    ClearRefinementsWidgetDescription as WDescription,
} from 'instantsearch.js/es/connectors/clear-refinements/connectClearRefinements'

import { Component, forwardRef, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'

import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'
import { AbstractInstantsearchWidgetComponent } from '@app-domains/algolia/abstract-instantsearch-widget.component'

@Component({
    selector: 'app-clear-refinements',
    template: `
        <app-button *ngIf="state?.canRefine"
                    (click)="clearRefinementsCommands$.next()"
                    theme="link"
        >
            {{ 'products.reset-filters' | translate}}
        </app-button>
    `,
})
export class ClearRefinementsComponent extends AbstractInstantsearchWidgetComponent<
WDescription,
CParams
> implements OnInit, OnChanges {

    public override readonly widgetName = 'ClearRefinements'

    /**
     * Optionally bind a trigger observable to programmatically clear refinements. Upon every emission
     * the UI refinements will be cleared
     */
    @Input()
    public clearRefinementsCommands$: Subject<void>
    private clearRefinementsCommandsSubscription: SubscriptionLike | null = null

    constructor(
        @Inject(forwardRef(() => AlgoliaInstantsearchComponent))
        public instantSearchInstance: AlgoliaInstantsearchComponent,
    ) {
        super()
    }

    public override ngOnInit(): void {
        this.createWidget(connectClearRefinements, {})
        super.ngOnInit()
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.clearRefinementsCommands$) {
            this.replaceClearCommandsStream(changes.clearRefinementsCommands$.currentValue)
        }
    }

    /**
     * Unsubscribes from the current stream of imperative clear commands, if any is set. If
     * the given value is an observable, it will be subscribed to as the new stream of clear commands.
     */
    private replaceClearCommandsStream(newStream: Observable<void> | null): void {
        this.clearRefinementsCommandsSubscription?.unsubscribe()
        this.clearRefinementsCommandsSubscription = null

        if (isNil(newStream)) {
            return
        }

        this.clearRefinementsCommandsSubscription = newStream.subscribe(() => this.state?.refine())
    }

}
